import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import Section from '../common/Section';
import Button from '../common/Button';
import './ContactCTA.css';

const ContactCTA = () => {
    const { t } = useTranslation();

    return (
        <Section background="black" className="contact-cta-section">
            <motion.div
                className="contact-cta-container"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <div className="cta-content">
                    <h2 className="cta-title">{t('contact.title')}</h2>
                    <p className="cta-subtitle">{t('contact.subtitle')}</p>

                    <div className="cta-actions">
                        <Link to="/contact">
                            <Button variant="primary">{t('contact.cta')}</Button>
                        </Link>
                    </div>

                    <div className="quick-contact">
                        <a href="tel:+201020008449" className="contact-link">
                            <PhoneIcon className="contact-icon" />
                            <span>+201020008449</span>
                        </a>
                        <a href="mailto:info@sigmaelevator-eg.com" className="contact-link">
                            <EnvelopeIcon className="contact-icon" />
                            <span>info@sigmaelevator-eg.com</span>
                        </a>
                    </div>
                </div>
            </motion.div>
        </Section>
    );
};

export default ContactCTA;
